module.exports = __webpack_public_path__ + "assets/notification_icon.6ee03f10.svg";